import api from "./API";

/** Plano efetivo do usuario logado, com o mapa de recursos liberados. */
export async function getMeuPlano() {
  const response = await api.get("/me/plano");
  return response.data?.record || null;
}

/** Catalogo de planos para a tela de contratacao. */
export async function getCatalogoPlanos() {
  const response = await api.get("/planos");
  return response.data?.records || [];
}

export function formatarPreco(centavos) {
  const valor = Number(centavos || 0) / 100;
  return valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 0 });
}
